<div class="flex-column gap">
    <app-check-input [form]="form" id="front" label="voucher.export.printFrontPage"></app-check-input>
    <app-check-input [form]="form" id="back" label="voucher.export.printBackPage"></app-check-input>
    <app-check-input [form]="form" id="archive" label="common.archive"></app-check-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="common.confirm"
        (primaryClickEvent)="save()"
        [primaryButtonDisability]="!form.value.front && !form.value.back"
        (secondaryClickEvent)="dialogRef.close()"
        [primaryButtonLoading]="loading"
    ></app-action-buttons>
</div>
